import styled from 'styled-components';

const COLORS = {
    error: {
        background: '#3D0A0A',
        text: '#FF5252',
        button: {
            border: '#FF5252',
            text: '#FF5252',
        },
    },
    warning: {
        background: '#2E2500',
        text: '#F8C84B',
        button: {
            border: '#F8C84B',
            text: '#F8C84B',
        },
    },
    info: {
        background: '#001A33',
        text: '#5BB3FF',
        button: {
            border: '#5BB3FF',
            text: '#5BB3FF',
        },
    },
};

export const BannerContainer = styled.div`
    width: 100%;
    min-height: 44px;
    padding: 10px 48px 10px 16px;

    display: flex;
    align-items: center;
    justify-content: center;
    gap: 12px;
    position: relative;

    background-color: ${({ severidade }) => COLORS[severidade]?.background ?? COLORS.warning.background};

    @media (max-width: 767px) {
        flex-direction: column;
        padding: 10px 48px 10px 16px;
        gap: 8px;
        min-height: auto;
    }
`;

export const BannerMessage = styled.p`
    margin: 0;
    font-family: 'Lato', sans-serif;
    font-size: 13px;
    font-weight: 400;
    line-height: 1.5;
    color: ${({ severidade }) => COLORS[severidade]?.text ?? COLORS.warning.text};
    text-align: center;
    cursor: default;
`;

export const BannerCTA = styled.a`
    all: unset;
    padding: 5px 14px;
    cursor: pointer;
    white-space: nowrap;

    border-radius: 50px;
    border: 1px solid ${({ severidade }) => COLORS[severidade]?.button.border ?? COLORS.warning.button.border};

    font-family: 'Lato', sans-serif;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 1px;
    text-transform: uppercase;
    color: ${({ severidade }) => COLORS[severidade]?.button.text ?? COLORS.warning.button.text};

    transition: background-color 0.15s ease;

    &:hover {
        background-color: rgba(255, 255, 255, 0.1);
    }
`;

export const CloseButton = styled.button`
    all: unset;
    cursor: pointer;
    position: absolute;
    right: 14px;
    top: 50%;
    transform: translateY(-50%);

    display: flex;
    align-items: center;
    justify-content: center;

    width: 20px;
    height: 20px;
    opacity: 0.7;

    &:hover {
        opacity: 1;
    }

    svg {
        width: 14px;
        height: 14px;
        stroke: ${({ severidade }) => COLORS[severidade]?.text ?? COLORS.warning.text};
    }

    @media (max-width: 767px) {
        top: 12px;
        transform: none;
    }
`;
